<template>

	<div class="Listing_button_1" :style="cssCard">
		<el-button v-for="(item,index) in lists" :type="item.type" :icon="item.icon" @click="classify(item.funt)"
			:key="index" size="medium">{{item.name}}</el-button>
		<!-- 	<el_dialog @changedia="changedia" :DialogTitle="DialogTitle" :centerDialogVisible="this.centerDialogVisible">
		</el_dialog> -->
	</div>

</template>

<script>
	// import el_dialog from '../My_dialog/index.vue'

	export default {
		props: [
			"lists"
		],
		data() {
			return {
				h: 10,
				w: 14,
				centerDialogVisible: false,
				DialogTitle: ''
			}
		},
		methods: {
			classify(i) {
				this.$emit(i)
			},
			changedia(value) {
				this.centerDialogVisible = value
			}
		},
		computed: {
			cssCard() {
				return {
					'--heigth': this.h + '%',
					'--width': this.w + '%',
				}
			}
		},
		components: {
			// el_dialog
		}
	}
</script>

<style scoped>
	.Listing_button_1 {
		border-radius: 8px;
		margin: 1rem;
		display: flex;
		background-color: var(--cont_backgound);
		padding: 10px;
	}

	@media (max-width: 1030px),
	(max-device-width: 1030px) {
		.Listing_button_1>>>.el-button {
			height: 3rem;
			width: 5.4rem;
			font-size: 1rem;
			display: flex;
			align-items: center;
			/* 垂直居中 */
			justify-content: center;
			/* 水平居中（可选） */
		}
	}
</style>